export default "__VITE_ASSET__CmX2BNtY__"